exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".is-talking[data-v-6340312c]{border-color:#b01202}", ""]);
